var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReloadWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6274 12.2193C17.3547 12.1443 17.0762 12.3027 17.0012 12.5736C16.1492 15.6423 13.3274 17.7858 10.1386 17.7858C6.21172 17.7858 3.01732 14.5912 3.01732 10.6646C3.01732 6.7377 6.21172 3.54331 10.1386 3.54331C12.4731 3.54331 14.6453 4.68296 15.9801 6.59528H11.6646C11.3835 6.59528 11.1559 6.8229 11.1559 7.10394C11.1559 7.38472 11.3835 7.6126 11.6646 7.6126H17.2598C17.5406 7.6126 17.7685 7.38472 17.7685 7.10394V1.50866C17.7685 1.22763 17.5406 1 17.2598 1C16.9788 1 16.7512 1.22763 16.7512 1.50866V5.92588C15.2214 3.79382 12.7704 2.52598 10.1386 2.52598C5.65092 2.52598 2 6.1769 2 10.6646C2 15.1522 5.65092 18.8032 10.1386 18.8032C13.7829 18.8032 17.0078 16.3532 17.9814 12.8455C18.0564 12.5748 17.898 12.2943 17.6274 12.2193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadWhite);
export default __webpack_public_path__ + "static/media/reload-white.973b370f436ffabde91151dca33ed4cb.svg";
export { ForwardRef as ReactComponent };